// import namor from 'namor'

import { COLUMNS } from '../config/Transaction/columns'


const range = len => {
  const arr = []
  for (let i = 0; i < len; i++) {
    arr.push(i)
  }
  return arr
}

const columnExtractor = () => {
  const accessors = COLUMNS.map((element) => {
    return element.accessor
  })

  return accessors
}

function getDescendantProp(obj, desc) {
    var arr = desc.split(".");
    while(arr.length && (obj = obj[arr.shift()]));
    return obj;
}

const objectRephraser = () => {
  const cols = COLUMNS.map(({Header,accessor}) => { return {Header : Header, accessor: accessor.replaceAll(".","__")} })
  return cols
}

const newTransaction = (transactions) => {
  const accessors = columnExtractor()
  const statusChance = Math.random()
  const trnsCols = transactions.map((rows) => {
    let obj = {}
    COLUMNS.forEach(({Header,accessor}) => { obj[accessor.replaceAll(".","__")] = getDescendantProp(rows, accessor) })
    return obj
  })

  return trnsCols
}

export default function makeData(transactions) {
  const rephrasedCols = objectRephraser()
  const makeDataLevel = (depth = 0) => {
    // const len = transactions.length
    const allTrnasactions = newTransaction(transactions)
    // return range(len).map(d => {
      return {
        dataRows: allTrnasactions,
        columns: rephrasedCols
      }
        // subRows: transactions[depth + 1] ? makeDataLevel(depth + 1) : undefined,
    // })
  }

  return makeDataLevel()
}
